import React from 'react'
import { cn } from '@/lib/utils'

interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  inline?: boolean
}

export const Form: React.FC<FormProps> = ({ inline, className, ...props }) => (
  <form className={cn(inline && 'flex items-center gap-2', className)} {...props} />
)
